import type { Observable as ObservableType } from 'rxjs/Observable';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';
import type { TimeFormat, TimeUnit } from '@atlassian/jira-time-tracking-formatter/src/types.tsx';

export type GlobalConfigResponse = {
	epicConfig: {
		colorFieldId: string;
		epicIssueTypeId: string;
		epicIssueTypeName: string;
		epicIssueTypeIconUrl: string;
		epicLinkFieldId: string;
		epicLinkFieldName: string;
	};
	sprintConfig: {
		sprintFieldId: string;
	};
	timeTrackingConfig: {
		daysPerWeek: number;
		hoursPerDay: number;
		defaultUnit: TimeUnit;
		timeFormat: TimeFormat;
	};
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (): ObservableType<GlobalConfigResponse> =>
	fetchJson$('/rest/greenhopper/3/globalconfig');
